import axios from 'axios';

const baseURL = import.meta.env.VITE_API_URL || '/api';

export const api = axios.create({
  baseURL,
  timeout: 120000, // OCR/解题请求较长
});


// ===== 跨子域共享登录（wenzao.site ⇄ xyz.wenzao.site）=====
// 1) 模块加载时（React 渲染前）从共享 Cookie 引导本站会话——RequireAuth 首渲染同步查 localStorage，
//    引导若放在异步 fetchMe 里会来不及，首渲染就被弹去 /login（曾致共享登录"不生效"）。
(function bootstrapSharedCookie() {
  if (!localStorage.getItem('token')) {
    const m = /(?:^|;\s*)token=([^;]+)/.exec(document.cookie);
    if (m) localStorage.setItem('token', decodeURIComponent(m[1]));
  }
})();

// 2) 反向补写：Cookie 功能上线前已登录的存量会话只有 localStorage——顺手把共享 Cookie 补上，
//    这样另一站才能引导。登录接口本身也会 Set-Cookie，这里兜底旧会话。
export function ensureSharedCookie() {
  const t = localStorage.getItem('token');
  if (t && !/(?:^|;\s*)token=/.test(document.cookie)) {
    document.cookie = 'token=' + encodeURIComponent(t) + '; domain=.wenzao.site; path=/; max-age=28800; secure; samesite=lax';
  }
}

// 自动带 token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 401 自动跳登录
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      const path = window.location.pathname;
      if (path !== '/login' && path !== '/') window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const setToken = (t: string | null) => {
  if (t) localStorage.setItem('token', t);
  else localStorage.removeItem('token');
};

// 统一取后端 publicMessage（配额 402 / 校验 400 / AI 502 等）
export const errText = (e: unknown): string =>
  (e as { response?: { data?: { error?: string } } })?.response?.data?.error || (e as Error)?.message || '请求失败';
